import { ModalCargaExamenPdfService } from './modal-carga-examen-pdf.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DatabaseService } from '@app/database/database.service';
import { BackgroundSyncService } from '@app/helpers/backgroundSync.service';
import { MessageAlertService } from '@app/shared/views/_messagesService/_messageAlertServices';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { Message } from 'primeng/api';
import { AttachUploadFileComponent } from '../attach-upload-file/attach-upload-file.component';

@Component({
	selector: 'app-modal-carga-examen-pdf',
	templateUrl: './modal-carga-examen-pdf.component.html',
	styleUrls: ['./modal-carga-examen-pdf.component.scss']
})
export class ModalCargaExamenPdfComponent implements OnInit {

	@Input() display;
	@Input() examen;
	@Output() hide = new EventEmitter<any>();
	attachedFile: any = {
		data: [],
		invalid: true,
		isEmpty: true
	};
	currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
	isOnline = true;
	enviandose = false;
	messages: Message[] = [];
	file: any;
	@ViewChild(AttachUploadFileComponent) attachUploadFile : AttachUploadFileComponent;

	constructor(
		private router: Router,
		private messageAlertServices: MessageAlertService,
		private connectionService: ConnectionService,
		private modalService: ModalCargaExamenPdfService,
		private databaseService: DatabaseService,
		private backgroundSyncService: BackgroundSyncService) {
	}

	ngOnInit(): void {
		this.connectionService.monitor().subscribe((connected: ConnectionState) => {
			this.isOnline = connected.hasNetworkConnection;;
		})
		this.isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
	}

	closeModal() {
		this.messages = [];
		this.hide.emit(false);
		this.enviandose = false;
		if(this.file){
			this.attachUploadFile.removeFile(this.file);
		}
	}

	cargarExamen() {
		this.messages = [];
		this.enviandose = true;
		if (this.isOnline) {
			this.cargarExamenOnline();
		} else {
			this.cargarExamenOffline();
		}
	}

	cargarExamenOnline() {
		this.modalService.cargarExamenConAdjunto(this.buildRequest()).subscribe(
			(response) => {
				this.openSuccessAlert('El exámen se cargó con éxito', 'examen');
			}, (error) => {
				this.formatResponseAndOpenError(error);
			}
		);
		this.databaseService.deleteItemFromTable(this.examen.id,
			`examenes${(this.examen.categoriaExamen === 'periodicos'
				? 'Periodicos'
				: 'Reevaluacion')}`);
		this.databaseService.deleteItemFromTable(this.examen.id,
			`examenes${(this.examen.categoriaExamen === 'periodicos'
				? 'PeriodicosFiltrados'
				: 'ReevaluacionFiltrados')}`);
		this.hide.emit(false);
	}

	cargarExamenOffline() {
		let dataToSend = this.buildRequest();
		dataToSend.cargadoEnAdjunto = true;
		let details = (this.examen?.modoVista === "edit") ? 'Los cambios en el examen fueron guardados correctamente' : 'El examen se guardó correctamente en Por enviar';
		this.examen.modoVista = null;
		this.databaseService.setExameneOnExamenesPorEnviarTable(
				this.examen, dataToSend, false, this.examen.categoriaExamen === 'periodicos'
					? 'Periodicos'
					: 'Reevaluacion',
				this.modalService.buildURL()
			)
			.then((response) => {
				this.databaseService.deleteItemFromTable(this.examen.id,
					`examenes${(this.examen.categoriaExamen === 'periodicos'
						? 'Periodicos'
						: 'Reevaluacion')}`);
				this.databaseService.deleteItemFromTable(this.examen.id,
					`examenes${(this.examen.categoriaExamen === 'periodicos'
						? 'PeriodicosFiltrados'
						: 'ReevaluacionFiltrados')}`);
				this.backgroundSyncService.registerEvent('save-examen');
				this.openSuccessAlert(details, 'examen');
			})
			.catch((e) => {
				this.messageAlertServices.setMessage(0, {
					severity: 'error',
					summary: '',
					detail:
						'Ha ocurrido un error. Por favor reinitente más tarde y disculpe las molestias ocasionadas',
					key: 'examen',
				});
			});
		this.hide.emit(false);
	}

	buildRequest() {
		let object = {
			userId: this.currentUser.userId,
			modelId: this.currentUser.modelId,
			username: this.currentUser.username,
			examenNumero: this.examen.id,
			adjunto: this.attachedFile.data,
			esEdicion: !!(this.examen?.modoVista === "edit" && this.isOnline) || null,
			cargadoOffline: !this.isOnline,
			cargadoEnAdjunto: null
		};
		return object;
	}

	openSuccessAlert(message: string, key: string): void {
		this.messageAlertServices.setMessage(0, {
			severity: 'success',
			summary: '',
			detail: message,
			key: key,
		});
		setTimeout(() => {
			this.returnToExams();
		}, 500);
	}

	formatResponseAndOpenError(error) {
		let message = error.error.message + ' ';
		message = message + error.error.errors.map((x) => {
			return x;
		}).join(' ');
		this.messageAlertServices.setMessage(0, {
			severity: 'error',
			summary: '',
			detail: message,
			key: 'examen',
		});
		setTimeout(() => {
			const header = document.querySelector('#templateContainer') as any;
			window.scroll(0, header.offsetTop - 150);
		}, 100);
	}

	getAttachedFiles(event: any): any {
		this.file = event.data[0];
		this.messages = [];
		const { errors } = event;
		this.attachedFile = event;
		if (!errors.isTypeValid) {
			this.messages = [{ severity: 'error', summary: 'Error al adjuntar', detail: 'Solo se aceptan los formatos de PDF, PNG o JPG' }];
			return;
		}
		if (!errors.isSizeValid) {
			this.messages = [{ severity: 'error', summary: 'Error al adjuntar', detail: 'El tamaño máximo del archivo debe ser de 5Mb' }];
			return;
		}
		if (!errors.isSizeNameValid) {
			this.messages = [{ severity: 'error', summary: 'Error al adjuntar', detail: 'El nombre del archivo no puede superar los 64 caracteres' }];
			return;
		}
	}

	deshabilitarBotonCargar() {
		return this.attachedFile.invalid;
	}

	returnToExams(): void {
		this.enviandose = false;
		this.router.navigate(['examenes']).then(()=> {
			this.router.navigate(['examenes/true']);
		});
	}

}